import { render } from "react-dom";
import Modal from "react-modal";
import "antd/dist/antd.css";
// TODO: integrate dark mode
// import "antd/dist/antd.dark.css";
import "./index.css";

import App from "./app";
import { IS_VERBOSE } from "./constants";
import { IntlProvider } from "./i18n/intl_provider";
import { StoresProvider } from "./stores";
import { Logger } from "./utilities";

import "./hljs";

if (IS_VERBOSE) {
  window.addEventListener("error", ({ error }) => {
    if (error) {
      Logger.error(error);
    }
  });
}

const root = document.querySelector("#root") as HTMLElement;
Modal.setAppElement(root);

render(
  <StoresProvider>
    <IntlProvider>
      <App />
    </IntlProvider>
  </StoresProvider>,
  root,
);
